import React, { useState } from "react";
import emailjs from "emailjs-com";

function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill in all fields.");
      return;
    }

    if (!validateEmail(formData.email)) {
      setStatus("Please enter a valid email address.");
      return;
    }

    emailjs
      .send(
        "service_zvkz3nf",
        "template_0pijbmr",
        {
          from_name: formData.name,
          reply_to: formData.email,
          message: formData.message,
        },
        "8pdx2L-wQ8y6lqtK5"
      )
      .then(
        () => {
          setStatus("Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.error("EmailJS Error:", error);
          setStatus("Oops! Something went wrong. Please try again.");
        }
      );
  };

  return (
    <section id="contact-section" className="py-16 bg-gradient-to-b from-gray-100 to-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-extrabold text-primary mb-6">Contact Us</h2>
        <p className="text-lg text-gray-600 mb-8">
          Let’s connect and create something amazing together.
        </p>
        <form
          className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg"
          onSubmit={handleSubmit}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input
              type="text"
              placeholder="Your Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
            <input
              type="email"
              placeholder="Your Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
          </div>
          <textarea
            placeholder="Your Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-3 mt-6 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            rows="5"
            required
          ></textarea>
          <button
            type="submit"
            className="mt-6 px-8 py-3 bg-primary text-white font-semibold rounded-full shadow-lg hover:bg-secondary transition"
          >
            Send Message
          </button>
        </form>
        {status && (
          <p
            className={`mt-4 text-lg ${
              status.includes("successfully") ? "text-green-600" : "text-red-600"
            }`}
          >
            {status}
          </p>
        )}
      </div>
    </section>
  );
}

export default ContactSection;
